var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var MailIcon = function (props) {
    return (_jsx("svg", __assign({ width: '30', height: '30', viewBox: '0 0 30 30', xmlns: 'http://www.w3.org/2000/svg' }, props, { children: _jsx("path", { d: 'M7.6875 10.75V20.875H22.3125V10.75H7.6875ZM10.1133 11.875H19.8867L15 15.127L10.1133 11.875ZM8.8125 12.3672L14.6836 16.2871L15 16.4805L15.3164 16.2871L21.1875 12.3672V19.75H8.8125V12.3672Z', fill: 'currentColor' }) })));
};
